var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-bar',{attrs:{"name":"devices","filter":_vm.getDevicesFilter}}),(_vm.deviceLocations && _vm.getDevicesReady)?_c('div',{staticStyle:{"min-height":"84vh"}},[_c('locations',{attrs:{"_deviceLocations":_vm.currentClient.client_name === 'shark'
          ? _vm.groupLocations
          : _vm.deviceLocations}})],1):_vm._e(),_c('filters')],1)}
var staticRenderFns = []

export { render, staticRenderFns }